export const ContractTypes = {
    AOM_1000: "AOM - 1000 On Request",
    AOM_2000: "AOM - 2000 Basic",
    AOM_3000: "AOM - 3000 Extended",
    AOM_4000: "AOM - 4000 Availability",
    AOM_5000: "AOM - 5000 Performance",
    AOM_Operational_Support: "AOM - Operational Support",
    POWER_PLUS: "Power Plus",
    COMMUNICATION_INFRASTRUCTURE_S: "Communication Infrastructure S",
    OTHER: "Other"
};

export const contractTypes: string[] = Object.values(ContractTypes);
